<div class="api-keys-container">
  <!-- Settings Navigation -->
  <app-settings-nav 
    [activeItem]="'api-keys'" 
    (navigationChange)="onNavigationChange($event)">
  </app-settings-nav>
  
  <div class="main-content">
    <!-- Page Header -->
    <div class="page-header">
      <h1 class="page-title">API Keys</h1>
      <p class="page-description">Manage your API keys for programmatic access.</p>
    </div>

    <!-- API Key Content -->
    <div class="api-key-content">
      <!-- OpenAI Section -->
      <div class="service-card">
        <div class="service-header">
          <div class="service-logo">
            <img src="images/openai.png" alt="OpenAI" class="service-icon">
            <span class="service-name">OPENAI</span>
          </div>
        </div>
        
        <p class="service-description">This key gives you access to OpenAI's GPT models. Treat it like a password and keep it secure.</p>
        
        <div class="api-key-input-container">
          <div class="api-key-input">
            <input 
              type="text" 
              class="api-input" 
              placeholder="Paste your key here"
              [(ngModel)]="openaiApiKey"
              (ngModelChange)="onOpenAIKeyChange()"
              (keyup.enter)="saveOpenAIKey()" />
          </div>
          <button class="action-button" 
                  [class.copy-button]="hasOpenAIKey" 
                  [class.save-button]="!hasOpenAIKey"
                  (click)="hasOpenAIKey ? copyOpenAIKey() : saveOpenAIKey()">
            {{ hasOpenAIKey ? 'Copy' : 'Save' }}
          </button>
        </div>
      </div>

      <!-- Anthropic Section -->
      <div class="service-card">
        <div class="service-header">
          <div class="service-logo">
            <img src="images/anthropic.png" alt="Anthropic" class="service-icon">
            <span class="service-name">ANTHROPIC</span>
          </div>
        </div>
        
        <p class="service-description">This key gives you access to Anthropic's Claude models. Treat it like a password and keep it secure.</p>
        
        <div class="api-key-input-container">
          <div class="api-key-input">
            <input 
              type="text" 
              class="api-input" 
              placeholder="Paste your key here"
              [(ngModel)]="anthropicApiKey"
              (ngModelChange)="onAnthropicKeyChange()"
              (keyup.enter)="saveAnthropicKey()" />
          </div>
          <button class="action-button" 
                  [class.copy-button]="hasAnthropicKey" 
                  [class.save-button]="!hasAnthropicKey"
                  (click)="hasAnthropicKey ? copyAnthropicKey() : saveAnthropicKey()">
            {{ hasAnthropicKey ? 'Copy' : 'Save' }}
          </button>
        </div>
      </div>

      <!-- Klaviyo Section -->
      <div class="service-card">
        <div class="service-header">
          <div class="service-logo">
            <img src="images/klavio.png" alt="Klaviyo" class="service-icon">
            <span class="service-name">KLAVIYO</span>
          </div>
        </div>
        
        <p class="service-description">This key gives you access to Klaviyo's email marketing platform. Treat it like a password and keep it secure.</p>
        
        <div class="api-key-input-container">
          <div class="api-key-input">
            <input 
              type="text" 
              class="api-input" 
              placeholder="Paste your key here"
              [(ngModel)]="klaviyoApiKey"
              (ngModelChange)="onKlaviyoKeyChange()"
              (keyup.enter)="saveKlaviyoKey()" />
          </div>
          <button class="action-button" 
                  [class.copy-button]="hasKlaviyoKey" 
                  [class.save-button]="!hasKlaviyoKey"
                  (click)="hasKlaviyoKey ? copyKlaviyoKey() : saveKlaviyoKey()">
            {{ hasKlaviyoKey ? 'Copy' : 'Save' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
